import {AskStatsV2} from '~/features/Ask/AskStatsV2/AskStatsV2';
import {PinProtect} from '~/features/Auth/PinProtect';

export const ReportsAskStatsScene = () => {
  return (
    <div className="bg-background min-h-screen">
      <PinProtect>
        <AskStatsV2 />
      </PinProtect>
    </div>
  );
};
